// @flow
import {observable, toJS} from 'mobx'
import * as cf from 'cf'
import type {Component, ID} from '../entities'
import gridStore from 'stores/grid'

export type Store = {
  byId: {[id:ID]:Component},
  allIds: ID[],
  setComponent: (component:Component) => void,
  removeComponent: (component:Component) => void,
  components: Component[],
  unusedDict: {[id:ID]:true}
}

const store:Store = observable(({
  byId: {},
  allIds: [],
  setComponent: (component) => {
    const {id} = component
    const exists = Boolean(store.byId[id])
    const gridAreaChanged = exists && component.props.gridArea !== store.byId[id].props.gridArea
    const oldGridArea = gridAreaChanged ? store.byId[id].props.gridArea : ''
    if(!exists) store.allIds.push(id)
    store.byId[id] = component
    if(gridAreaChanged) updateCf(true, oldGridArea, component.props.gridArea)
    else updateCf(false)
  },
  removeComponent: component => {
    delete store.byId[component.id]
    store.allIds = store.allIds.filter(id => id !== component.id)
    updateCf(false)
  },
  get components(){
    return store.allIds.map(id => store.byId[id]).filter(Boolean)
  },
  get unusedDict(){
    const activeGridAreas = Object.keys(gridStore)
      .filter(size => gridStore[size].active)
      .filter(size => gridStore[size])
      .map(size => gridStore[size]._data ? gridStore[size]._data.components : [])
      .reduce((dict, list) => {
        list.forEach(gridArea => (dict[gridArea] = true))
        return dict
      },{})
    return store.components
      .filter(comp => !activeGridAreas[comp.props.gridArea])
      .reduce((dict, comp) => {
        dict[comp.id] = true
        return dict
      }, {})
  }
}:Store))

export default store

window.componentStore = store

function updateCf(gridAreaChanged:boolean, oldGridArea?:string='', newGridArea?:string=''){
  const story = cf.getStory()
  const jsStore = toJS(store)
  const components = jsStore.allIds.map(id => jsStore.byId[id])
  let newStory = { 
    ...story, 
    COMPONENTS: components
  }
  if(gridAreaChanged){
    newStory = {
      ...newStory,
      GRID: Object.keys(newStory.GRID).reduce((result, gridName) => {
        let newContent = newStory.GRID[gridName].content
        while(newContent.includes(` ${oldGridArea} `)) {
          newContent = newContent.replace(` ${oldGridArea} `, ` ${newGridArea} `)
        }
        result[gridName] = {
          ...newStory.GRID[gridName],
          content: newContent,
          components: newStory.GRID[gridName].components.map(comp => comp === oldGridArea ? newGridArea : comp)
        }
        return result
      }, {})
    }
  }
  cf.update(newStory)
}

cf.addChangeListener(story => {
  const components = story.COMPONENTS
  store.byId = components.reduce((p,n) => (p[n.id]=n) && p, {})
  store.allIds = components.map(comp => comp.id)
})


// WEBPACK FOOTER //
// ./src/stores/components.js